export enum MFE {
  FORMATION,
  ENSEIGNEMENT,
  //   FORMATIONENSEIGNEMENT = 'FORMATION / ENSEIGNEMENT',
}
